/*** IMPORTS FROM imports-loader ***/
var define = false;

import sample from './sample.js';

// Shuffle a collection.
export default function shuffle(obj) {
  return sample(obj, Infinity);
}




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/shuffle.js
// module id = 184
// module chunks = 0